const state = () => ({
  isSidePanelOpen: false,
  guideField: {},
  guideData: {
    title: '',
    sections: [],
    ai_prompt_message: '',
    ai_suggestions: []
  }
})

const getters = {
  getSidePanelState: (state) => state.isSidePanelOpen,
  getGuide: (state) => state.guideData,
  getGuideField: (state) => state.guideField
}

const mutations = {
  toggleSidePanel (state) {
    state.isSidePanelOpen = !state.isSidePanelOpen
  },
  openSidePanel (state) {
    state.isSidePanelOpen = true
  },
  closeSidePanel (state) {
    state.isSidePanelOpen = false
  },
  setGuide (state, guideData) {
    state.guideData = guideData
  },
  setGuideField (state, guideField) {
    state.guideField = guideField
  }
}

const actions = {
  toggleSidePanel ({ commit }) {
    commit('toggleSidePanel')
  },
  openSidePanel ({ commit }) {
    commit('openSidePanel')
  },
  closeSidePanel ({ commit }) {
    commit('closeSidePanel')
  },
  setGuide ({ commit }, guideData) {
    commit('setGuide', guideData)
  },
  setGuideField ({ commit }, guideField) {
    commit('setGuideField', guideField)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
